import { createI18n } from "vue-i18n";
import zhCN from "./zh-CN";
import enUS from "./en-US";

// 定义支持的语言类型
type SupportedLocales = "zh-cn" | "en-us";

// 获取浏览器语言设置
const getBrowserLanguage = (): SupportedLocales => {
  const language = navigator.language.toLowerCase();
  const locales: SupportedLocales[] = ["zh-cn", "en-us"];
  const locale = locales.find((locale) => language.includes(locale)) || "zh-cn";
  return locale;
};

// 创建i18n实例
const i18n = createI18n({
  legacy: false, // 使用Composition API
  locale:
    (localStorage.getItem("locale") as SupportedLocales) ||
    getBrowserLanguage(),
  fallbackLocale: "zh-cn" as SupportedLocales,
  messages: {
    "zh-cn": zhCN,
    "en-us": enUS,
  },
});

// 切换语言的方法
export const setLocale = (locale: SupportedLocales) => {
  i18n.global.locale.value = locale;
  localStorage.setItem("locale", locale);
  document.querySelector("html")?.setAttribute("lang", locale);
};

export type { SupportedLocales };
export default i18n;
